import React from 'react';
import "./Modal.css"
const Modal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  children,
  // Destructure all the className props with default fallbacks
  overlayClassName = "nfc-modal-overlay",
  dialogClassName = "nfc-modal-dialog",
  headerClassName = "nfc-modal-header",
  titleClassName = "nfc-modal-title",
  contentClassName = "nfc-modal-content",
  footerClassName = "nfc-modal-footer",
  confirmBtnClassName = "nfc-modal-btn nfc-modal-confirm-btn",
  cancelBtnClassName = "nfc-modal-btn nfc-modal-cancel-btn"
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={overlayClassName} onClick={onClose}>
      <div className={dialogClassName} onClick={(e) => e.stopPropagation()}>
        <div className={headerClassName}>
          <h2 className={titleClassName}>{title}</h2>
        </div>
        <div className={contentClassName}>
          {children}
        </div>
        <div className={footerClassName}>
          <button className={cancelBtnClassName} onClick={onClose}>
            Cancel
          </button>
          <button className={confirmBtnClassName} onClick={onConfirm}>
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;